import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 bg-accent-500">
      <div className="w-full px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-serif mb-3">
          准备好开启您的<strong>直播互动</strong>之旅了吗？
        </h2>
        <p className="text-foreground-800/80 text-sm max-w-lg mx-auto mb-8">
          立即注册，加入千万用户的直播互动社区，发现更多精彩内容
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/caibiao"
            className="px-8 py-3 bg-foreground-950 hover:bg-foreground-900 text-background-50 font-semibold rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            免费注册体验
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-transparent hover:bg-foreground-950/10 text-foreground-900 font-semibold border border-foreground-900/30 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}